/**
 * 🏗 Model which represents the created user bot stats in the specific bot type
 */
export default class CreatedBotStats {
  constructor(
    public id: string,
    public startTime: Date,
    public exchange: string,
    public market: string,
    public totalTrades: number,
    public daysActive: number,
    public roi: number,
    public bahROI: number,
    public status: boolean,
    public sharpe?: number,
    public sortino?: number,
    public maximumDrawdown?: number
  ) {}

  public get marketOutperformance(): number {
    return this.roi - this.bahROI
  }

  /**
   * USED FOR TESTING ONLY
   */
  public static generateExamples(): CreatedBotStats[] {
    let botStats: any[] = [];

    for (let i = 0; i < Math.random() * 10 + 10; i++) {
      botStats.push(
        new CreatedBotStats(
          i.toString(),
          new Date(
            Math.floor(Math.random() * (1600353061 - 1600243000)) + 1600243000
          ),
          "Binance",
          "BTC:USDT",
          Math.floor(Math.random() * 8 + 10),
          Math.floor(Math.random() * 10 + 10),
          5.45,
          3.02,
          i % 2 == 0,
          3,
          3,
          3
        )
      );
    }
    return botStats;
  }
}
